export const SPORT = {
  SOCCER: 'soccer',
  VOLLEYBALL: 'volleyball',
  BASKETBALL: 'basketball',
  AMERICAN_FOOTBALL: 'american-football',
  SNOOKER: 'snooker',
  TENNIS: 'tennis',
  MMA: 'mma',
  TABLE_TENNIS: 'table-tennis',
  GOLF: 'golf',
  CRICKET: 'cricket',
  ICE_HOCKEY: 'ice-hockey'
} as const
